const GET_CURRENT_USER_ORGANIZATION_LIST_PATH = 'v2/user/organization-list';
export { GET_CURRENT_USER_ORGANIZATION_LIST_PATH };
